<template>
    <div class="copyright">
      <a class="m-r-20" href="https://beian.miit.gov.cn/">沪ICP备17035868号-1</a>
      <a href="#">沪公网安备 31011502006690号</a>
    </div>
</template>

<script>
export default {
  name: "PCCopyright",
  props: {},
  components: {
  },
  data() {
    return {
    };
  }
};
</script>
